import PreactImage from '@/components/snippets/image/image'
import { OnBoardingModal } from './onBoarding'
import { useEffect, useState } from 'preact/hooks'
import Icon from '@/components/snippets/icon/icon'
import { memo } from 'preact/compat'
import { accountTranslations } from '../helpers/translations'
export const AccountOnBoarding = memo(() => {
  const [viewOnboarding, setViewOnboarding] = useState(false)

  const handleViewOnboarding = () => setViewOnboarding((o) => !o)

  useEffect(() => {
    // Check session storage to determine if we need to trigger onboarding
    if (localStorage.getItem('isFirstLogin') === 'true') {
      handleViewOnboarding()
      localStorage.removeItem('isFirstLogin')
    }
  }, [])

  if (viewOnboarding) {
    return (
      <OnBoardingModal
        logo={accountGlobal.onboarding.logo}
        handleOutsideOpen={handleViewOnboarding}
        isOpen={viewOnboarding}
      />
    )
  }

  return (
    <div className={'min-h-96 w-full'}>
      <div className={'flex h-full flex-col justify-between md:flex-row'}>
        <div className={'flex w-full flex-col items-center justify-center gap-4 bg-neutrals-base p-10 md:w-1/2'}>
          <div>
            <img src={accountGlobal?.onboarding?.feature_logo} alt="Fit Club Logo" className="h-52 min-w-60" />
          </div>
          <div className={'text-center'}>
            {accountTranslations.onboarding.title}
          </div>
          <button className={'btn btn-solid-accent btn-md justify-center'} onClick={handleViewOnboarding}>
            {accountTranslations.onboarding.cta}
          </button>
        </div>

        <div className={'lg:w-1/2'}>
          <PreactImage
            imageClass="fit object-bottom"
            className={'aspect-4/5 h-full w-full object-cover'}
            key={'id'}
            imageUrl={[accountGlobal?.onboarding?.feature_image]}
          />
        </div>
      </div>
    </div>
  )
})
